<div class="container locker-checkout">
  <div class="row">
    <div class="col-sm-12 col-md-5 form-reserve">

      <div *ngIf="type==0" class="mb-3">
        <!--
        <div *ngIf="!appService.autenticado()">
          <p>{{'checkout.doYouCustomPassword'|traduccion}}
            <a class="nav-link p-0 d-inline-block text-muted" rel="tooltip" title="Login" data-placement="bottom" (click)="login()" target="_self">{{'checkout.signinOrSignup'|traduccion}}</a>
          </p>
        </div>
        -->
        <div *ngIf="appService.autenticado()">
          <p>{{'checkout.loginAs'|traduccion}} {{appService.usuario.username}}, 
            <a class="nav-link p-0 d-inline-block text-muted" rel="tooltip" title="Logout" data-placement="bottom" (click)="logout()" target="_self">{{'checkout.logout'|traduccion}}</a>
          </p>
        </div>
      </div>

      <form id="form-checkout" [formGroup]="heroForm">
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="mb-3">
                <input formControlName="name" type="text" class="form-control" id="name" placeholder="Nombre" [readonly]="appService.autenticado()"/>
                <div *ngIf="name.invalid && (name.dirty || name.touched)" class="alert alert-danger">
                  <div *ngIf="name.errors.required">
                    {{'name.errors.required'|traduccion}}
                  </div>
                  <div *ngIf="name.errors.minlength">
                    {{'name.errors.minlength'|traduccion}}
                  </div>
                  <div *ngIf="name.errors.forbiddenName">
                    {{'name.errors.forbiddenName'|traduccion}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="mb-3">
                <input formControlName="email" type="email" class="form-control" id="email" placeholder="Email" [readonly]="appService.autenticado()" />
                <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert alert-danger">
                  <div *ngIf="email.errors.required">
                    {{'email.errors.required'|traduccion}}
                  </div>
                  <div *ngIf="email.errors.minlength">
                    {{'email.errors.minlength'|traduccion}}
                  </div>
                  <div *ngIf="email.errors.email">
                    {{'email.errors.forbiddenName'|traduccion}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="mb-3">
                <!--
                <select formControlName="extension" class="form-control" id="extension" placeholder="Extension">
                  <option selected>{{'Seleccionar'|traduccion}}</option>
                  <option *ngFor="let phone of appService.phone" value="{{phone.dial_code}}">{{phone.name}}</option>
                </select>
                -->
                <input formControlName="extension" type="text" class="form-control" id="extension" placeholder="Extension" (blur)="transformExtension()"/>
                <div *ngIf="extension.invalid && (extension.dirty || extension.touched)" class="alert alert-danger">
                  <div *ngIf="extension.errors.required">
                    {{'extension.errors.required'|traduccion}}
                  </div>
                  <div *ngIf="extension.errors.minlength">
                    {{'extension.errors.minlength'|traduccion}}
                  </div>
                  <div *ngIf="extension.errors.pattern">
                    {{'extension.errors.pattern'|traduccion}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <input formControlName="telephoneNumber" type="text" class="form-control" id="telephone_number" max="20"
                  placeholder="{{'checkout.telephoneNumber'|traduccion}}" />
                <div *ngIf="telephoneNumber.invalid && (telephoneNumber.dirty || telephoneNumber.touched)" class="alert alert-danger">
                  <div *ngIf="telephoneNumber.errors.required">
                    {{'telephoneNumber.errors.required'|traduccion}}
                  </div>
                  <div *ngIf="telephoneNumber.errors.minlength">
                    {{'telephoneNumber.errors.minlength'|traduccion}}
                  </div>
                  <div *ngIf="telephoneNumber.errors.pattern">
                    {{'telephoneNumber.errors.pattern'|traduccion}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label class="form-label">{{'label.info.raison.phone'|traduccion}}</label>
              </div>
            </div>
          </div>

          <div *ngIf="appService.autenticado() && isModeKey && !isRenovation()" class="row">
            <div class="col">
              <p>{{'checkout.customPassword'|traduccion}}</p>
            </div>
          </div>

          <div *ngIf="appService.autenticado() && isModeKey && !isRenovation()" class="row">
            <div class="col">
              <div class="mb-3">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">0{{appService.usuario.id}}+</span>
                  </div>
                  <input formControlName="provisionalPasswordLocker" type="number" class="form-control pass"
                    id="provisional_locker_password" placeholder="{{'checkout.deliver'|traduccion}}" minlength="4" maxlength="4" />
                  <small id="provisional_locker_password" class="form-text text-muted">{{'checkout.passwordToDeliver'|traduccion}} {{formatPin(provisionalPasswordLocker.value)}}</small>
                  <div
                    *ngIf="provisionalPasswordLocker.invalid && (provisionalPasswordLocker.dirty || provisionalPasswordLocker.touched)"
                    class="alert alert-danger">
                    <div *ngIf="provisionalPasswordLocker.errors.required">
                      {{'passwordLocker.errors.required'|traduccion}}
                    </div>
                    <div *ngIf="provisionalPasswordLocker.errors.minlength || provisionalPasswordLocker.errors.maxlength">
                      {{'passwordLocker.errors.minlength'|traduccion}}
                    </div>
                    <div *ngIf="provisionalPasswordLocker.errors.pattern">
                      {{'passwordLocker.errors.pattern'|traduccion}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">0{{appService.usuario.id}}+</span>
                  </div>
                  <input formControlName="checkoutPasswordLocker" type="number" class="form-control pass" id="locker_password"
                    placeholder="{{'checkout.pickup'|traduccion}}" minlength="4" maxlength="4" />
                  <small id="provisional_locker_password" class="form-text text-muted">{{'checkout.passwordToPickup'|traduccion}} {{formatPin(checkoutPasswordLocker.value)}}</small>
                  <div *ngIf="checkoutPasswordLocker.invalid && (checkoutPasswordLocker.dirty || checkoutPasswordLocker.touched)"
                    class="alert alert-danger">
                    <div *ngIf="checkoutPasswordLocker.errors.required">
                      {{'passwordLocker.errors.required'|traduccion}}
                    </div>
                    <div *ngIf="checkoutPasswordLocker.errors.minlength || checkoutPasswordLocker.errors.maxlength">
                      {{'passwordLocker.errors.minlength'|traduccion}}
                    </div>
                    <div *ngIf="checkoutPasswordLocker.errors.pattern">
                      {{'passwordLocker.errors.pattern'|traduccion}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          
          <div class="row">
            <div class="col">
              <p>{{'checkout.info.discountCode'|traduccion}}</p>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <input formControlName="discountCode" type="text" maxlength="8" oninput="this.value = this.value.toUpperCase()" [readonly]="discountValidated" class="form-control" id="discount_code" placeholder="Código descuento" />
                  </div>
                  <div class="col">
                    <button *ngIf="!discountValidated" class="btn btn-primary btn-round" [disabled]="(discountCode.value == null || discountCode.value == '') || (discountCode.invalid && (discountCode.dirty || discountCode.touched))" (click)="validateDiscount()">
                      {{'checkout.bt.validateDiscount'|traduccion}}
                      </button>
                      <button *ngIf="discountValidated" class="btn btn-primary btn-round" (click)="deleteDiscount()">
                        {{'checkout.bt.deleteDiscount'|traduccion}}
                      </button>
                  </div>
                </div>
                <div *ngIf="discountCode.invalid && (discountCode.dirty || discountCode.touched)" class="alert alert-danger">
                  <div *ngIf="discountCode.errors.required">
                    {{'discountCode.errors.required'|traduccion}}
                  </div>
                  <div *ngIf="discountCode.errors.minlength">
                    {{'discountCode.errors.minlength'|traduccion}}
                  </div>
                  <div *ngIf="discountCode.errors.forbiddenName">
                    {{'discountCode.errors.forbiddenName'|traduccion}}
                  </div>
                </div>
                <div *ngIf="heroForm?.errors?.discountValidated" class="alert alert-danger mt-2">
                  <div>
                    {{'discountCode.errors.discountValidated'|traduccion}}
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <!--
          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label for="insurance" class="checkbox-inline">
                  <input formControlName="insurance" type="checkbox" id="insurance" />
                  {{'label.info.raison.segure'|traduccion}}</label>
              </div>
            </div>
          </div>
          -->
          <div class="row">
            <div class="col">
              <div class="mb-3">
                <label for="agreement" class="checkbox-inline">
                  <input formControlName="agreement" type="checkbox" id="agreement" />
                  {{'label.checkout.agreement'|traduccion}} <a target="_blank" routerLink="/terms-conditions">{{'checkout.agreement.open'|traduccion}}</a>
                </label>
                <div *ngIf="agreement.invalid && (agreement.dirty || agreement.touched)" class="alert alert-danger">
                  <div *ngIf="agreement.errors.required">
                    {{'agreement.errors.required'|traduccion}}
                  </div>
                  <div *ngIf="agreement.errors.minlength">
                    {{'agreement.errors.minlength'|traduccion}}
                  </div>
                  <div *ngIf="agreement.errors.forbiddenName">
                    {{'agreement.errors.forbiddenName'|traduccion}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- /container -->
      </form> <!-- /form -->

    </div> <!-- /col form-reserve -->
    <div class="col-sm-12 col-md-5 offset-md-0 offset-md-2 resumen-reserve">

      <div class="col-sm">
        <div class="mb-3">
          <h4 class="text-light mt-0">{{'checkout.reserve'|traduccion}}</h4>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="card-text">
            <div>
              <div class="resumen-location">
                <p>{{infoCart.kioskAddress}}</p>
              </div>
              <div class="resumen-date">
                <p>{{'checkout.from'|traduccion}} {{this.infoCart.startDate | date: appService.FORMAT_DATETIME : appService.TIMEZONE_OFFSET() : 'es'}}</p>
                <p>{{'checkout.to'|traduccion}} {{this.infoCart.endDate | date: appService.FORMAT_DATETIME : appService.TIMEZONE_OFFSET() : 'es'}}</p>
              </div>
              <!--
              <div class="resumen-locker">
                <p>{{'checkout.locker'|traduccion}} {{parameters.type|traduccion}}</p>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>

      <div class="c-resumen">
        <div class="">
          <div class="container card">
            <div *ngFor="let item of infoCart.items" class="order mt-4">

            <!-- {--
              <div *ngIf="infoCart.resumen[0].priceType!=null" class="row">
                <div class="col">
                  <div class="mb-3 bt-type-payment">
                    <button *ngIf="parameters.items[0].priceType=='RECURRENT'" (click)="onChangePrice($event)" value="UNIQUE" class="btn btn-outline-primary" [class.btTypePayment]="infoCart.resumen[0].priceType=='UNIQUE'" [disabled]="infoCart.resumen[0].priceType=='RECURRENT'">{{'checkout.UNIQUE'|traduccion}}</button>
                    <button *ngIf="parameters.items[0].priceType=='UNIQUE' || parameters.items[0].priceType==null" (click)="onChangePrice($event)" value="RECURRENT" class="btn btn-outline-primary" [class.btTypePayment]="infoCart.resumen[0].priceType=='RECURRENT'" [disabled]="infoCart.resumen[0].priceType=='UNIQUE'">{{'checkout.RECURRENT'|traduccion}}</button>                    
                  </div>
                </div>
              </div>
              --}
              -->
              <!-- TODO revisar para eliminar -->
              <div *ngIf="price != null && price.items['KEYU']" class="row">
                <div *ngFor="let p of price.items['KEYU'].alternativePrices" class="col">
                  <div class="mb-3 bt-type-payment">
                    
                    <button
                    (click)="onChangePrice($event, p)" 
                    [value]="p"
                    class="btn btn-outline-primary w-100" 
                    [class.bt-type-payment-recurrent]="infoCart.resumen[0].priceType==p.type" 
                    [disabled]="infoCart.resumen[0].id==p.id">
                    {{p.type|traduccion}} <br> {{p.price}}{{'checkout.divisa'|traduccion}} / {{p.period}} {{p.unit|traduccion}}
                  </button>

                  </div>
                </div>
              </div>

              <div class="row">
                <p class="col font-weight-bold">{{'checkout.locker'|traduccion}} {{item.categoryCode|traduccion}}</p>
              </div>
              <div class="dropdown-divider"></div>
              <div class="row">
                <div class="col">
                  <p class="">{{item.unitPrice}}{{'checkout.divisa'|traduccion}} / {{item.period}} {{item.unit|traduccion}}</p>
                </div>
                <div class="col"></div>
                <div class="col">
                  <p [class.overwrite-price-discount]="item.descriptionDiscount">{{item.totalPriceWithoutDiscount}}{{'checkout.divisa'|traduccion}}</p>
                </div>
              </div>
              <div *ngIf="item.descriptionDiscount" class="row discount">
                <div class="col">
                  <p class="">{{item.descriptionDiscount}}</p>
                </div>
                <div class="col-4">
                  <p class="">{{item.totalPrice}} {{'checkout.divisa'|traduccion}}</p>
                </div>
              </div>
            </div>
            <div class="mt-4"></div>
            <div class="dropdown-divider"></div>
            <div class="row">
              <div class="col">
                <p class="font-weight-bold">{{'checkout.total'|traduccion}}</p>
              </div>
              <div class="col"></div>
              <div class="col">
                <p class="total font-weight-bold">{{infoCart.total}}€</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div> <!-- /resumen-reserve -->
  </div>
</div>